import type { PauseOrResumeOrderActionProps } from './PauseOrResumeOrderAction.types';
import { PauseOrderActionReason } from './PauseOrResumeOrderAction.types';
import type { LabsGqlRemoveOrderHoldMutationVariables } from '@orthly/graphql-operations';
import { useRemoveOrderHoldMutation } from '@orthly/graphql-react';
import { useChangeSubmissionFn } from '@orthly/ui';
import { Button } from '@orthly/ui-primitives';
import React from 'react';

type RemoveOrderHoldVars = LabsGqlRemoveOrderHoldMutationVariables['data'];
type ResumeOrderActionProps = Omit<PauseOrResumeOrderActionProps, 'preselectedOption'>;

export const useRemoveOrderHold = (refetch: () => void) => {
    const [submitRemoveHoldMtn] = useRemoveOrderHoldMutation();
    const removeHoldMtnSubmitter = (data: RemoveOrderHoldVars) => submitRemoveHoldMtn({ variables: { data } });

    return useChangeSubmissionFn<any, [RemoveOrderHoldVars]>(removeHoldMtnSubmitter, {
        successMessage: () => ['The order has successfully been resumed. No further action is required.'],
        onSuccess: async () => {
            refetch();
        },
    });
};

export const ResumeOrderAction: React.VFC<ResumeOrderActionProps> = ({ order, refetch, buttonVariant, leftAlign }) => {
    const holdIsDDPHold = order.hold_details?.hold_category === PauseOrderActionReason.ReviewDesign;

    const { submit: submitRemoveHold } = useRemoveOrderHold(refetch);

    const onSubmit = () => {
        void submitRemoveHold({ orderId: order.id });
    };

    return (
        <Button
            data-test={'resume-order-button'}
            leftAlign={leftAlign}
            variant={buttonVariant}
            startIcon={'PlayArrowIcon'}
            onClick={onSubmit}
        >
            Resume order{holdIsDDPHold ? ' to view design' : ''}
        </Button>
    );
};
